import { useQuery } from "@tanstack/react-query";
import { api } from "lib/api";

const campSociosKeys = {
  list() {
    return ["dashboard", "camp", "socios"];
  },
};

export function useDashboardCampSocios(enabled = true) {
  return useQuery({
    queryKey: campSociosKeys.list(),
    queryFn: () => api("/dashboard/camp/socios"),
    enabled,
    staleTime: 20_000,
  });
}
